<template>
    <label :for="id" class="form-label">
        <slot></slot>
    </label>
</template>

<script>
    export default {
        name: 'FormLabel',
        props: {
            id: String
        }
    };
</script>

<style lang="scss">
    .form-label {
        color: $form-label-color;
        margin-bottom: 6px;
    }
</style>